import { render, staticRenderFns } from "./IconUsers.vue?vue&type=template&id=3b12cd13&scoped=true&"
import script from "./IconUsers.vue?vue&type=script&lang=js&"
export * from "./IconUsers.vue?vue&type=script&lang=js&"
import style0 from "./IconUsers.vue?vue&type=style&index=0&id=3b12cd13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12cd13",
  null
  
)

export default component.exports